module.exports = __webpack_public_path__ + "img/Logo_ideen.64ddd5bc.png";